import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import AfricanGreyImage from '../../../images/paracheirodon_innesi.jpg';

const StyledLabel2Col = ({
  logoUrl,
	styleElements
}) => {
  // Create the element styles
	const headerBackground = {background: styleElements.headerBgColor};
	const headerFont = {color: styleElements.headerFontColor};
	const detailBackground = {backgroundColor: styleElements.detailBgColor};
	const detailFont = {color: styleElements.detailFontColor};
  const valueBackground = {backgroundColor: styleElements.valueBgColor};
  const valueFont = {color: styleElements.valueFontColor};
  const priceBackground = {backgroundColor: styleElements.priceBgColor};
  const priceFont = {color: styleElements.priceFontColor};
  const labelBackground = {background: styleElements.labelBgColor};
  const tableBackground = {borderColor: styleElements.labelBgColor};
  const labelBorder = {borderColor: styleElements.labelBorderColor};

  return (
		<div className="label-main 2col" style={labelBorder}>
      <div className="label-title" style={headerBackground}>
        <span className="label-control form-control" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_LAT_NAME')}</span>
        <span className="label-control form-control latin-name" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_NAME')}</span>
      </div>
        <div className="label-content" style={labelBackground}>
          <img src={AfricanGreyImage} className="float-left" />
          <table className="float-left" cellPadding="0" cellSpacing="0">
            <tbody>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_2')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_2')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_1')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_1')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_4')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_3')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_3')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_4')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_5')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_5')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_6')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_6')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('PLU')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>12345</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="label-footer" style={priceBackground}>
          <span className="label-control form-control float-left txt-price" style={priceFont}>{I18n.t('CUSTOM_LABEL_PET_PRICE')}</span>
          <div className="label-logo">
            <img src={logoUrl}  />
          </div>
          <div className="barcode-customize barcode float-right"/> 
        </div>    
    </div>
	);
};

StyledLabel2Col.propTypes = {
	logoUrl: PropTypes.string.isRequired,
  styleElements: PropTypes.object.isRequired
};

export default StyledLabel2Col;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/StyledLabel2Col.js
 **/